import DataTableContainer from './components/DataTableContainer';
import Filters from './components/Filters';
import HistorialDocumentoDrawer from './components/HistorialDocumentoDrawer';
import QuickFilterDataTable from './components/QuickFilterDataTable';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import useDocuments from './hooks/useDocuments';

function ConsultaDocumentos() {
    const {
        inputTypeDocOptions,
        filters,
        extraFilters,
        loadingEnabledDocs,
        fetchingEnabledDocs,
        disabledFilters,
        handleChangeExtraFilters,
        handleClearFilters,
        onTabChange,
        handleSearch,
        tabValue,
        dataTableLoading,
        savingDownload,
        setFilters,
        documents,
        handleDownloadDocument,
        handleOpenDrawer,
        handleDeleteDocument,
        ...props
    } = useDocuments();

    return (
        <>
            <SectionTitle
                title="Consulta de Documentos"
                subtitle="Listado de aplicaciones habilitadas para consumir la web API"
            />

            <Filters
                handleSearch={handleSearch}
                handleChangeExtraFilters={handleChangeExtraFilters}
                extraFilters={extraFilters}
                loadingEnabledDocs={loadingEnabledDocs}
                fetchingEnabledDocs={fetchingEnabledDocs}
                inputTypeDocOptions={inputTypeDocOptions}
                handleClearFilters={handleClearFilters}
                disabledFilters={disabledFilters}
            />

            <QuickFilterDataTable tabValue={tabValue} handleChangeTabValue={onTabChange} />

            <DataTableContainer
                loading={dataTableLoading}
                savingDownload={savingDownload}
                filters={filters}
                setFilters={setFilters}
                documents={documents}
                handleDownloadDocument={handleDownloadDocument}
                handleOpenDrawer={handleOpenDrawer}
                handleDeleteDocument={handleDeleteDocument}
            />

            <HistorialDocumentoDrawer {...props} />
        </>
    );
}

export default ConsultaDocumentos;
